import { useQueryParam } from "hooks/utils";

export const useCourseSlug = () => {
  const courseSlug = useQueryParam("courseSlug");

  if (typeof courseSlug !== "string") {
    throw new Error("courseSlug is not available");
  }

  return courseSlug;
};
